import { wmfetch } from "@/helpers/wmfetch";

// 智能巡查报告详情，调用 wlgl-server /intelligent/report/detail
export function getInspectionReportDetail(data) {
  return wmfetch({
    url: "/api/intelligent/report/detail",
    method: "get",
    params: data,
  });
}

// 微信 OAuth code 换取 wlgl-token
export function getWechatCode(data) {
  return wmfetch({
    url: "/api/wechat",
    method: "get",
    params: data,
  });
}
